export type SignUpFormDraftItem = {
  value: string;
  instanceId?: number | null;
  required?: boolean;
};

export type SignUpFormWriteItem = {
  instanceType: string;
  priorityOrder: number;
  instanceId?: number | null;
  required?: 1;
};

/** Bonus keeps its promo link. Other items, including chooseBonus, stay independent. */
export function toSignUpFormWriteItem(
  item: SignUpFormDraftItem,
  priorityOrder: number,
): SignUpFormWriteItem {
  if (item.value === "bonus") {
    return {
      instanceType: "bonus",
      instanceId: item.instanceId,
      priorityOrder,
    };
  }

  const base: SignUpFormWriteItem = {
    instanceType: item.value,
    priorityOrder,
  };

  if (item.required) {
    return { ...base, required: 1 };
  }

  return base;
}

export function toSignUpFormWriteItems(items: SignUpFormDraftItem[]): SignUpFormWriteItem[] {
  return items.map((item, index) => toSignUpFormWriteItem(item, index + 1));
}
